export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	pikachuoriginal: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachuhoenn: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachusinnoh: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachuunova: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachukalos: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachualola: {
		inherit: true,
		abilities: {0: "Static"},
	},
	pikachupartner: {
		inherit: true,
		abilities: {0: "Static"},
	},
	koffing: {
		inherit: true,
		abilities: {0: "Levitate"},
	},
	weezing: {
		inherit: true,
		abilities: {0: "Levitate"},
	},
	ralts: {
		inherit: true,
		eggGroups: ["Amorphous"],
	},
	kirlia: {
		inherit: true,
		eggGroups: ["Amorphous"],
	},
	gardevoir: {
		inherit: true,
		eggGroups: ["Amorphous"],
	},
	trapinch: {
		inherit: true,
		eggGroups: ["Bug"],
	},
	vibrava: {
		inherit: true,
		eggGroups: ["Bug"],
	},
	flygon: {
		inherit: true,
		eggGroups: ["Bug"],
	},
	magnezone: {
		inherit: true,
		evoType: "levelExtra",
		evoCondition: "in a special magnetic field",
	},
	leafeon: {
		inherit: true,
		evoType: "levelExtra",
		evoCondition: "near a Moss Rock",
	},
	glaceon: {
		inherit: true,
		evoType: "levelExtra",
		evoCondition: "near an Ice Rock",
	},
	gallade: {
		inherit: true,
		eggGroups: ["Amorphous"],
	},
	heatran: {
		inherit: true,
		abilities: {0: "Flash Fire", H: "Flame Body"},
		unreleasedHidden: true,
	},
	aegislash: {
		inherit: true,
		baseStats: {hp: 60, atk: 50, def: 150, spa: 50, spd: 150, spe: 60},
	},
	aegislashblade: {
		inherit: true,
		baseStats: {hp: 60, atk: 150, def: 50, spa: 150, spd: 50, spe: 60},
	},
	pumpkaboosmall: {
		inherit: true,
		abilities: {0: "Pickup", 1: "Frisk"},
	},
	pumpkaboolarge: {
		inherit: true,
		abilities: {0: "Pickup", 1: "Frisk"},
	},
	gourgeistsmall: {
		inherit: true,
		abilities: {0: "Pickup", 1: "Frisk"},
	},
	gourgeistlarge: {
		inherit: true,
		abilities: {0: "Pickup", 1: "Frisk"},
	},
	hawlucha: {
		inherit: true,
		eggGroups: ["Human-Like"],
	},
	bergmite: {
		inherit: true,
		eggGroups: ["Monster"],
	},
	avalugg: {
		inherit: true,
		eggGroups: ["Monster"],
	},
	noibat: {
		inherit: true,
		eggGroups: ["Flying"],
	},
	noivern: {
		inherit: true,
		eggGroups: ["Flying"],
	},
	vikavolt: {
		inherit: true,
		evoType: "levelExtra",
		evoCondition: "near a special magnetic field",
	},
	crabominable: {
		inherit: true,
		evoType: "levelExtra",
		evoCondition: "at Mount Lanakila",
	},
	lycanroc: {
		inherit: true,
		evoCondition: "in Pokemon Sun/Ultra Sun",
	},
	lycanrocmidnight: {
		inherit: true,
		evoCondition: "in Pokemon Moon/Ultra Moon",
	},
	tapukoko: {
		inherit: true,
		abilities: {0: "Electric Surge"},
	},
	tapulele: {
		inherit: true,
		abilities: {0: "Psychic Surge"},
	},
	tapubulu: {
		inherit: true,
		abilities: {0: "Grassy Surge"},
	},
	tapufini: {
		inherit: true,
		abilities: {0: "Misty Surge"},
	},
	pyroak: {
		inherit: true,
		baseStats: {hp: 120, atk: 70, def: 105, spa: 95, spd: 90, spe: 60},
		abilities: {0: "Rock Head", 1: "Battle Armor", H: "White Smoke"},
	},
	voodoom: {
		inherit: true,
		baseStats: {hp: 90, atk: 85, def: 80, spa: 105, spd: 80, spe: 110},
	},
	mumbao: {
		inherit: true,
		unreleasedHidden: true,
	},
	jumbao: {
		inherit: true,
		unreleasedHidden: true,
	},
};
